import * as React from 'react';
import BaseComponent from '../BaseComponent';
import {Button, Card, CardBody, Col, Modal, Row} from "reactstrap";
import * as PropTypes from 'prop-types';
// import label from "../../message/Label"
import label from 'enqc-utilities/src/label/Label'
import HorizontalLine from "../Widget/HorizontalLine";
import MyCardImage from "../Card/MyCardImage";
import WarningLabel from "../Widget/WarningLabel";
import ApplicationIcons from "enqc-utilities/src/misc/ApplicationIcons";

/*= (message, okCallback, cancelCallback) =>*/
export default class CreateReleaseVerificationBlockedModal extends BaseComponent{



    render(){
        let {message, reference, onClickClose} = this.props
        if(!onClickClose){
            onClickClose = () => {}
        }
        return (
            <>
                {super.render()}
                <Modal
                    autoFocus={false}
                    size="md"
                    centered={true}
                    isOpen={this.props.show}
                    backdrop={true}>
                    <Card style={{textAlign:'center'}}>
                        <CardBody>
                            <Row>
                                <Col>
                                    <MyCardImage style={{padding:'32px', width:'40%'}} src={ApplicationIcons.Icons.error}/>
                                </Col>
                            </Row>
                            <HorizontalLine/>
                            <Row>
                                <Col>
                                    <h3>
                                        <strong>
                                            {label.Warning}
                                        </strong>
                                    </h3>
                                    <h2 className="text-secondary bold"><strong>{reference}</strong></h2>
                                    <HorizontalLine/>
                                    <WarningLabel style={{fontSize:'16px'}} message={message} show={message}/>
                                </Col>
                            </Row>
                            <HorizontalLine/>
                            <Row>
                                <Col style={{textAlign:'left'}}>
                                    <Button
                                        block
                                        color={"danger"}
                                        onClick={() => {
                                            onClickClose()
                                        }}>
                                        {label.Close}
                                    </Button>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Modal>
            </>
           )
    }
}

CreateReleaseVerificationBlockedModal.propTypes = {
    message:PropTypes.string.isRequired,
    reference:PropTypes.string.isRequired,
    show:PropTypes.bool.isRequired,
    onClickClose:PropTypes.func.isRequired,
}
